import React, { useContext, useEffect } from 'react';
import { AppointementStepper } from '../components/features/AppointementStepper';
import { Column } from '../components/shared/Column';
import { Grid } from '../components/shared/Grid';

import { BaseLayout } from '../components/template/BaseLayout';
import { Loader } from '../components/shared/Loader';
import { FormContext } from '../store/MLI/MLIContext';

export const Appointement = () => {

  useEffect(() => {
    const script = document.createElement('script');
    const {hostname} = window.location;
    let env = hostname.indexOf('staging') !== -1 || hostname.indexOf('acc') !== -1 || hostname.indexOf('test') !== -1 || hostname.indexOf('localhost') !== -1 ? 'staging.' : '';
    script.type = 'text/javascript';
    script.defer = true;
    script.async = true;
    script.innerHTML = `(function (e, r, s) { 
      if (typeof r > "u") return; 
      let n = "PexipEngage", a = "script"; 
      e[n] = e[n] || function () { 
        e[n].q = e[n].q || []; 
        let g = arguments; 
        if (g[0] === "init") { 
          if (e[n].loaded) return; 
          let i = r.getElementsByTagName(a)[0], 
              t = r.createElement(a); 
          t.defer = !0, 
          t.async = !0, 
          t.src = s, 
          e[n].loaded = !0, 
          i?.parentNode?.insertBefore(t, i); 
          return 
        } 
        return new Promise((i, t) => e[n].q.push([g, i, t])) 
      }; 
    })(window, document, "https://plugin.${env}pexipengage.com/hypotheker/pexip-engage-plugin.js"); 
    window.PexipEngage("init");`;

    document.body.appendChild(script);

    // Cleanup script on unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

	const { isLoading } = useContext(FormContext);
    return (
        <BaseLayout>
            <Grid>
                <Column cols={[12, null, null, 7]}>
                    <AppointementStepper />
                </Column>
            </Grid>
					<Loader isLoading={isLoading} />
        </BaseLayout>
    );
};
